import {sharedCorporateFooterBackgroundColors} from '@adv-mt/mt-shared-corporate-footer'
import {sharedTopbarMaxContentWidths} from '@adv-mt/mt-shared-topbar'

export const LAYOUT_BASIC_BASE_CLASS_NAME = 'mt-LayoutBasic'
export const LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME = `${LAYOUT_BASIC_BASE_CLASS_NAME}Container`
export const LAYOUT_BASIC_FULL_HEIGHT_BASE_CLASS_NAME = `${LAYOUT_BASIC_BASE_CLASS_NAME}FullHeight`
export const LAYOUT_BASIC_FULL_WIDTH_BASE_CLASS_NAME = `${LAYOUT_BASIC_BASE_CLASS_NAME}FullWidth`

export const BACKGROUND_COLORS = {
  INHERIT: 'inherit',
  WHITE: 'white'
}

export const FOOTER_BACKGROUND_COLORS_DICTIONARY = {
  [BACKGROUND_COLORS.INHERIT]: sharedCorporateFooterBackgroundColors.INHERTIT,
  [BACKGROUND_COLORS.WHITE]: sharedCorporateFooterBackgroundColors.WHITE
}

export const MAX_CONTENT_WIDTHS = {
  MEDIUM: 'medium', // 992px
  LARGE: 'large', // 1280px
  EXTRA_LARGE: 'extraLarge' // 1800px
}

export const MARGIN_TOP_SIZES = {
  EXTRA_LARGE: 'extraLarge',
  LARGE: 'large',
  MEDIUM: 'medium',
  NONE: 'none',
  SMALL: 'small'
}

export const SHARED_TOPBAR_MAX_CONTENT_WIDTHS_DICTIONARY = {
  [MAX_CONTENT_WIDTHS.MEDIUM]: sharedTopbarMaxContentWidths.MEDIUM,
  [MAX_CONTENT_WIDTHS.LARGE]: sharedTopbarMaxContentWidths.LARGE,
  [MAX_CONTENT_WIDTHS.EXTRA_LARGE]: sharedTopbarMaxContentWidths.EXTRA_LARGE
}
